'use strict';

var FaresPanelConfig = function FaresPanelConfig($stateProvider) {
  $stateProvider.state('app.fares', {
    url: '/workflow/fares',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER;FIM'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/fares-panel.html'),
        controller: 'FaresPanelController'
      },
      'mainToolbar': {
        template: require('../templates/fares-toolbar.html'),
        controller: 'FaresToolbarController'
      }
    }
  });
};
FaresPanelConfig.$inject = ['$stateProvider'];
module.exports = FaresPanelConfig;